import React from 'react';
import { BookOpenIcon, ListChecksIcon, SearchIcon, SmartphoneIcon, TableIcon, ZapIcon } from 'lucide-react';
import { Section, SectionTitle } from '../Section';
import { CtaBlock } from '../CtaBlock';
import { included } from '../../data/content';
const icons = {
  BookOpen: BookOpenIcon,
  Zap: ZapIcon,
  Table: TableIcon,
  Search: SearchIcon,
  ListChecks: ListChecksIcon,
  Smartphone: SmartphoneIcon
};
export function Included() {
  return <Section data-id="element-179" data-mp="37iqj3kn2lahm">
      <SectionTitle eyebrow="📲 Get instant access" subtitle="What will you receive immediately?" data-id="element-180" data-mp="3bm4z4bb0dqv2">
        Inside your digital pack
      </SectionTitle>

      <ul className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-181" data-mp="3gey3uz6h8z75">
        {included.map(item => {
        const Icon = icons[item.icon as keyof typeof icons];
        return <li key={item.title} className="flex flex-col rounded-2xl border border-white/10 bg-ink-800 p-5" data-id="element-182" data-mp="3qcvq5h4s0lx4">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-teal/15" data-id="element-183" data-mp="2r3v5fkboq9yj">
                <Icon className="h-5 w-5 text-teal-bright" aria-hidden="true" data-id="element-184" data-mp="2m3pfc8l2cvik" />
              </span>
              <h3 className="mt-3 text-base font-bold uppercase leading-tight text-white" data-id="element-185" data-mp="2h4mel0c49bge">
                {item.title}
              </h3>
              <p className="mt-2 text-[15px] leading-snug text-white/65" data-id="element-186" data-mp="2d558q5ss2cap">
                {item.description}
              </p>
            </li>;
      })}
      </ul>

      <CtaBlock className="mt-10" headline="Everything lands in your inbox instantly" data-id="element-187" data-mp="34vrsh9yhxto2" />
    </Section>;
}